import { render, staticRenderFns } from "./ClickOutside.vue?vue&type=template&id=76da7976&lang=pug&"
import script from "./ClickOutside.vue?vue&type=script&lang=ts&"
export * from "./ClickOutside.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports